import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, DatePicker, Select, Button, Card, message, Row, Col } from 'antd';
import { apiClient } from '../../config/apiClient';
import dayjs from 'dayjs';

const RegistroAlumno = () => {
  const [form] = Form.useForm();
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Cargar categorías
  useEffect(() => {
    const loadCategorias = async () => {
      try {
        const response = await apiClient.get('/categorias');
        if (response.ok) {
          const data = await response.json();
          setCategorias(data.filter(cat => cat.cat_activo));
        }
      } catch (error) {
        console.error('Error al cargar categorías:', error);
      }
    };
    loadCategorias();
  }, []);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const dataToSend = {
        nombre: values.nombre,
        apellido: values.apellido,
        fechaNacimiento: values.fechaNacimiento.format('YYYY-MM-DD'),
        sexo: values.sexo,
        email: values.email,
        telefono: values.telefono,
        categoria: values.categoria,
      };

      const response = await apiClient.post('/solicitudes-alumnos', dataToSend);
      
      if (response.ok) {
        message.success('Solicitud enviada correctamente. Te contactaremos pronto.');
        form.resetFields();
        navigate('/login');
      } else {
        const error = await response.json();
        message.error(error.message || 'Error al enviar la solicitud');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al enviar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      background: '#1a1a1a',
      padding: '20px'
    }}>
      <Card style={{ width: '100%', maxWidth: 600, background: '#2d2d2d', borderColor: '#404040' }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <h1 style={{ marginBottom: '8px', color: '#ffffff' }}>Registro de Alumno</h1>
          <p style={{ color: '#b0b0b0' }}>Completa el formulario para solicitar tu registro</p>
        </div>
        
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="nombre"
                label="Nombre"
                rules={[
                  { required: true, message: 'El nombre es requerido' },
                  { max: 100, message: 'El nombre no puede exceder 100 caracteres' },
                ]}
              >
                <Input placeholder="Ingrese el nombre" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="apellido"
                label="Apellido"
                rules={[
                  { required: true, message: 'El apellido es requerido' },
                  { max: 100, message: 'El apellido no puede exceder 100 caracteres' },
                ]}
              >
                <Input placeholder="Ingrese el apellido" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="fechaNacimiento"
            label="Fecha de Nacimiento"
            rules={[
              { required: true, message: 'La fecha de nacimiento es requerida' },
            ]}
          >
            <DatePicker
              style={{ width: '100%' }}
              format="DD/MM/YYYY"
              placeholder="Seleccione la fecha de nacimiento"
            />
          </Form.Item>

          <Form.Item
            name="sexo"
            label="Sexo"
            rules={[
              { required: true, message: 'El sexo es requerido' },
            ]}
          >
            <Select
              placeholder="Seleccione el sexo"
            >
              <Select.Option value="Masculino">Masculino</Select.Option>
              <Select.Option value="Femenino">Femenino</Select.Option>
              <Select.Option value="Otro">Otro</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'El email es requerido' },
              { type: 'email', message: 'El formato del email no es válido' },
            ]}
          >
            <Input placeholder="ejemplo@email.com" />
          </Form.Item>

          <Form.Item
            name="telefono"
            label="Teléfono"
            rules={[
              { required: true, message: 'El teléfono es requerido' },
            ]}
          >
            <Input placeholder="Ingrese el teléfono" />
          </Form.Item>

          <Form.Item
            name="categoria"
            label="Categoría"
            rules={[
              { required: true, message: 'La categoría es requerida' },
            ]}
          >
            <Select
              placeholder="Seleccione la categoría"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            >
              {categorias.map(cat => (
                <Select.Option key={cat.cat_id} value={cat.cat_id} label={cat.cat_descripcion}>
                  {cat.cat_descripcion}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              Enviar Solicitud
            </Button>
          </Form.Item>

          <Form.Item>
            <Button type="link" block onClick={() => navigate('/login')}>
              Volver al inicio de sesión
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default RegistroAlumno;

